import React, { FunctionComponent, useMemo } from "react";
import Select, { ValueType } from "react-select";
import {
  EvidencePeriodData,
  MasterDataInFilter,
  MasterDataSchools,
  School
} from "../../../../../../../store/onboarding/types";
import { ApplicationState } from "../../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  changeDataSchoolsFilter,
} from "../../../../../../../store/dataFilter/actions";
import { connect, useSelector } from "react-redux";

type StateProps = {
  dataSchoolsFilter?: Array<number>;
};

type DispatchProps = {
  changeDataSchoolsFilter: (id?: number[]) => any;
};

type Props = StateProps & DispatchProps;

const SchoolsFilter: FunctionComponent<Props> = ({
  dataSchoolsFilter,
  changeDataSchoolsFilter
}) => {
   const schoolsDataInFilter = useSelector<
      ApplicationState,
      MasterDataSchools[]
    >((s) => s.onboarding.masterDataInFilter.schools);

  const options: MasterDataSchools[] = useMemo(() => 
    schoolsDataInFilter.filter((school) => school.school_id_ !== null)
  ,[schoolsDataInFilter])

  const handleSchoolChange = (value: ValueType<MasterDataSchools, true>) => {
    if (value && (value as MasterDataSchools[]).length > 0) {
      changeDataSchoolsFilter((value as MasterDataSchools[]).map((t) => t.school_id_!));
    } else {
      changeDataSchoolsFilter();
    }
  };

  return (
    <>
      <h4 className="font-weight-bold m-0">School(s)</h4>
      <Select
        isMulti
        isClearable
        styles={{ menu: (styles) => ({ ...styles, zIndex: 100 }) }}
        options={options}
        value={options.filter(
          (x) => dataSchoolsFilter && dataSchoolsFilter.includes(x.school_id_!)
        )}
        getOptionLabel={(school: MasterDataSchools) => `${school.school_name_}`}
        getOptionValue={(school: MasterDataSchools) => school.school_id_.toString()}
        onChange={handleSchoolChange}
      />
    </>
  );
};

const mapStateToProps = ({
  dataFilter
}: ApplicationState): StateProps => {
  return {
    dataSchoolsFilter: dataFilter.dataSchoolsFilter,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      changeDataSchoolsFilter: changeDataSchoolsFilter
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SchoolsFilter);
